<template>
  <div id="app" class="container is-fluid is-marginless"  v-if="!hasParam">
    <ServiceAgreement :sidebar-opened="showSidebar"></ServiceAgreement>
    <ContractorQuiz :sidebar-opened="showSidebar"></ContractorQuiz>
    <template v-if="!isAuth">
      <Navbar></Navbar>
      <router-view/>
    </template>
    <template v-else>
      <div class="content-view">
        <sidebar :reduce="reduce" @item-click="hideSidebarIfMobile"></sidebar>
        <section class="main" :class="{ 'main_reduce': reduce }">
          <user-navbar :reduce.sync="reduce"></user-navbar>
          <div class="module">
            <keep-alive :exclude="['CardPaymentAcceptance']">
              <router-view/>
            </keep-alive>
          </div>
        </section>
      </div>
    </template>
    <splash></splash>
    <preloader :is-preloading="isPreloading"></preloader>
  </div>

</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import * as MUTATIONS from '@/store/mutations';
import Navbar from './components/Navbar.vue';
import UserNavbar from './components/Navbar/UserNavbar.vue';
import Splash from './components/Splash.vue';
import Preloader from './components/Preloader.vue';
import Sidebar from './components/Sidebar.vue';
import ServiceAgreement from './components/Modal/ServiceAgreement.vue';
import ContractorQuiz from './components/Modal/ContractorQuiz.vue';
import { SWITCH_USER } from './store/actions';
import { SET_SPLASH, SET_WINDOW_WIDTH } from './store/mutations';
import { LOAD_CONSTANTS } from './store/modules/constant/actions';


export default {
  name: 'App',
  components: {
    UserNavbar,
    Preloader,
    Splash,
    Navbar,
    Sidebar,
    ServiceAgreement,
    ContractorQuiz,
  },

  data() {
    return {
      PERSONAL_INFO_ACCESS: { resource: 'personal-info', code: 'access' },
      REPORTS_APPLICATIONS_ACCESS: { resource: 'reports-applications', code: 'access' },
      MANAGE_CONTRACTORS_ACCESS: { resource: 'manage-contractors', code: 'access' },
      reduce: false,
      opened: true,
      canCancel: false,
      hasParam: false,
    };
  },

  watch: {
    isAuth(value) {
      if (value) {
        this.$store.dispatch(`constant/${LOAD_CONSTANTS}`);
      }
    },
  },

  computed: {
    ...mapState('auth2', ['isAuth']),
    ...mapState(['isPreloading']),
    ...mapGetters('user', ['hasPrivilege']),
    ...mapState('auth2', { showSidebar: (state) => !state.needConfirmProviderAgreement && !state.needQuiz }),
  },
  created() {
    const param = this.$route.query.action;
    if (param) {
      this.hasParam = true;
    }
  },

  mounted() {
    this.resizeSidebar();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    window.addEventListener('resize', this.resizeSidebar);
    document.addEventListener('click', this.handleAppClick);
  },

  beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
    window.removeEventListener('resize', this.resizeSidebar);
    document.removeEventListener('click', this.handleAppClick);
  },

  methods: {
    ...mapMutations({ setSidebarWidth: MUTATIONS.SET_SIDEBAR_WIDTH }),
    switchBack() {
      const userId = this.$store.state.auth.id;
      this.$store.commit(SET_SPLASH, true);
      this.$store.dispatch(SWITCH_USER, userId)
        .then(() => { this.$store.commit(SET_SPLASH, false); });
    },

    resizeSidebar() {
      const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
      const isTablet = () => window.matchMedia('(max-width: 1023px)').matches;
      this.reduce = isTablet() || isMobile();
      // if you abruptly switch from a large resolution to a small one,
      // then the resize event works with an intermediate resolution.
      setTimeout(() => {
        this.$store.commit(SET_WINDOW_WIDTH);
        const sidebar = document.getElementById('main-sidebar');
        if (sidebar) {
          const sidebarContent = sidebar.querySelector('div.sidebar-content');
          if (sidebarContent) {
            const computedStyles = window.getComputedStyle(sidebarContent);
            const width = computedStyles.getPropertyValue('width');
            this.setSidebarWidth(Number(width.substring(0, width.length - 2)));
          }
        }
      }, 300);
    },

    hideSidebarIfMobile() {
      const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
      if (isMobile()) this.reduce = true;
    },

    handleOrientationChange() {
      this.resizeSidebar();
    },

    handleAppClick(event) {
      this.$root.$emit('app-click', event);
    },
  },

};
</script>

<style scoped lang="stylus">
  .dd-menu
    outline none !important

    &.is-text:hover
      background transparent

    &.is-text:active
      background transparent

    &.is-text::-moz-focus-inner
      border: 0;

    &.is-text:focus
      background transparent
      border none
      outline none !important
      box-shadow none
</style>
